import R from 'ramda';
import {simpleCrud} from '../factories/simple-crud-component-makers.js';


export const modal =  R.curry((template) => {

	let modalConfig = {
		data: {
			is_open: false
		},
		methods: {
			openModal() {
				this.is_open = true
			},
			closeModal() {
				this.is_open = false
			},
			onCreateSuccess(body, input) {
					this.list.splice(0, 0, body.data);
					input.target.reset();
					this.close();
			},

			onUpdateSuccess(body, input) {
					let index = input.target.dataset.index;
					this.list.splice(index, 1, body.data);
					this.close();
			}
		}
	};
	return simpleCrud(template,modalConfig);
});



// WEBPACK FOOTER //
// ./resources/assets/js/vue/components/modal.js